import React from 'react';
import { useSelector } from 'react-redux';
import { Flex, Spin } from 'antd';

// Define the selector to get the loading state from the Redux store
const GlobalLoader: React.FC = () => {
  // Typing the selector with the RootState type from your Redux store
  const loading = useSelector((state: any) => state.loader.loading);

  // If not loading, return null
  if (!loading) return null;

  return (
    <>
      <Flex align="center" gap="middle">
        <div className="global-loader" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
        }}>
          <div className="spinner-border text-primary" role="status">
            {/* <span className="sr-only">Loading...</span> */}
            <Spin size="large" />
          </div>
        </div>
      </Flex>
    </>
  );
};

export default GlobalLoader;
